module.exports = __webpack_public_path__ + "img/face_avatar.08846a75.png";